<div class="modal-section-header w-100">
    {{sectionTitle ? (sectionTitle | translate) : ' '}}
</div>
